import { NumericFormat, NumericFormatProps } from "react-number-format";

type NumberTextProps = NumericFormatProps & {
  value?: number | null;
};
export const NumberText = ({ value, ...props }: NumberTextProps) => {
  return value != null ? (
    <NumericFormat
      {...props}
      displayType="text"
      value={value}
      thousandSeparator
    />
  ) : (
    <></>
  );
};
